export const USER = 'User'

export const MICROTREND = 'Microtrend'

export const MACROTREND = 'Macrotrend'
export const COMPANY_MACROTREND = 'CompanyMacrotrend'
export const PUBLIC_MACROTREND = 'PublicMacrotrend'
export const MACROTRENDS = [MACROTREND, COMPANY_MACROTREND, PUBLIC_MACROTREND]
